import React from 'react';
import { HARDCODED_PRODUCTKEY } from '../../../common/constant';
import SubmitButton from '../../submitButton/SubmitButton';

function TryNowHeader({ productName, onBack }) {
  return (
    <div className=" pb-0 d-md-flex justify-content-between align-items-center w-100">
      <div className=" cursor-pointer font_600" onClick={onBack}>
        ← <span className="mx-1">{productName}</span>
      </div>
      <SubmitButton
        style={{ marginTop: '0px', height: '36px' }}
        className="mt-3 mt-md-0 rounded-pill btn-master-line me-3 me-lg-0"
        onClick={() =>
          (window.location.href = `${window.baseUrl}/subscription?productKey=${HARDCODED_PRODUCTKEY}`)
        }
        label="Add Credits"
      />
    </div>
  );
}

export default TryNowHeader;
